export class Invoice {
    id: string;
    accountNumber: string;
    invoicedDate: Date;
    createdDate: Date;
    invoiceNumber: string;
    filename: string;
}

export class InvoiceDocumentModel {
    EndPointURL: string;
    Token: string;
    AccountId: string;
    InvoiceId: string;
    filename: string;
}

export class InvoicesModel {
    //EndPointURL: string;
    Token: string;
    AccountId: string[];
}

export class Statement {
    id: string;
    createdDate: Date;
    accountNumber: string;
}

export class StatementDocumentModel {
    EndPointURL: string;
    Token: string;
    StatementId: string;
    AccountId: string;
}

export class StatementModel {
    EndPointURL: string;
    Token: string;
    AccountId: string[];
}

export class Certificate {
    id: string;
    accountNumber: string;
    invoiceNumber: string;
    invoiceDate: Date;
    accountId: string;
    selected: boolean
}

export class CertificateModel {
    EndPointURL: string;
    Token: string;
    AccountId: string[];
}

export class CertificateDocumentModel {
    //EndPointURL: string;
    Token: string;
    CertificateId: string;
    AccountId: string;
}

export class CertificatesContainerModel {
    CertificateDocumentModel: CertificateDocumentModel[];
    Name: string;
    Email: string;
    NumberOfFiles: string;
    RequestDate: string;
}

export class Ebilling {
    accountId: string;
    accountNumber: string;
    ledger: string;
    enabled: boolean;
    email1: string;
    email2: string;
    email3: string;
}

export class LedgerLine {
    id: string;
    documentId: string;
    createdDate: Date;
    paidDate: Date;
    amount: number;
    reference: string;
    accountNumber: string;
    transactionType: string;
    customerNumber: string;
    subAccountNumber: string;
    customerReference: string;
}


export class LedgerLines {
    ledgerLines: LedgerLine[];
    ledger: string;
    accountNumber: string;
    accountId: string;
    outstandingBalance: number;
}

export class LedgerLineModel {
    EndPointURL: string;
    Token: string;
    AccountId: string;
}
export class LedgerLineModelNew {
    EndPointURL: string;
    Token: string;
    Accounts: string[];
}

export class EbillingModel {
    Ebilling: Ebilling;
    EndPointURL: string;
    Token: string;
    AccountId: string;
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicing.ts